import {
  addTenantMachineTranslationResource,
  updateTenantMachineTranslationResource,
  getTenantMachineTranslationResources,
  removeTenantMachineTranslationResource,
} from '../../services/api-calls';

import resourceConfigurationHoc from '../common/resourceConfigurationHoc';
import { AWS_ROLE_ARN_REGEX } from '../../../../global/constants';
import { tenantAwsAccountsSubject$ } from '../../../../global/api-calls';
import { take } from 'rxjs/operators';

const engineOptions = [
  { value: 'MTS', label: 'MTS' },
  { value: 'AMT', label: 'AMT' },
  { value: 'SESIA', label: 'SESIA' },
  { value: 'GEC', label: 'GEC' },
  { value: 'SAGEMAKER', label: 'SAGEMAKER' },
];
const engineSet = new Set(
  engineOptions.map(o => {
    return o.value;
  })
);

const MachineTranslation = resourceConfigurationHoc(
  'Machine Translation',
  {
    uuid: {
      header: 'ID',
      type: 'text',
      width: 500,
    },
    awsAccountId: {
      header: 'Aws Account Id',
      type: 'editableInput',
      validationHandler: async input => {
        return tenantAwsAccountsSubject$
          .pipe(take(1))
          .toPromise()
          .then(awsAccounts => {
            const awsAccountIds = new Set(
              awsAccounts.map((awsAccount, index) => {
                return awsAccount.awsAccountId;
              })
            );
            if (!awsAccountIds.has(input)) {
              throw Error(`must be one of registered accounts [${Array.from(awsAccountIds.values()).join(', ')}]`);
            }
          });
      },
    },
    engine: {
      header: 'Engine',
      type: 'editableSelect',
      selectOptions: engineOptions,
      validationHandler: async input => {
        if (!engineSet.has(input)) {
          throw Error(`must be one of [${Array.from(engineSet.values()).join(', ')}]`);
        }
      },
    },
    model: {
      header: 'Model',
      type: 'editableInput',
    },
    endpoint: {
      header: 'Endpoint',
      type: 'editableInput',
    },
    modelVariant: {
      header: 'Model Variant',
      type: 'editableInput',
    },
    roleArn: {
      header: 'Role Arn',
      type: 'editableInput',
      validationHandler: async input => {
        if (!AWS_ROLE_ARN_REGEX.test(input)) {
          throw Error('cannot be empty and must match valid AWS role ARN');
        }
      },
    },
  },
  addTenantMachineTranslationResource,
  updateTenantMachineTranslationResource,
  removeTenantMachineTranslationResource,
  getTenantMachineTranslationResources
);

export default MachineTranslation;
